import { request } from '@umijs/max';

/** 作业报告列表 GET /robot/report/list */
export function getReportList(
  data: API.PageParams & API.REPORT.ReportSearch = {
    pageNum: 1,
    pageSize: 12,
  },
) {
  const { pageNum, pageSize, ...searchQuery } = data;
  return request<API.ListResponse<API.REPORT.Report>>('/robot/report/list', {
    method: 'GET',
    params: data,
  });
}

/** 查询未读报告数量 GET /robot/report/hasUnread */
export function getUnreadReportCount(params?: API.REPORT.ReportSearch) {
  return request<API.CommonResponse<number>>('/robot/report/hasUnread', {
    method: 'GET',
    params,
  });
}

/** 作业报告详情 GET /robot/report/{reportId} */
export function getReportDetail(reportId: number) {
  return request<API.CommonResponse<API.REPORT.Report>>(
    `/robot/report/${reportId}`,
    {
      method: 'GET',
    },
  );
}

/** 新增报告 GET /robot/report/add */
export function createReport(data: Omit<API.REPORT.Report, 'reportId'>) {
  return request<API.CommonResponse<API.REPORT.Report>>('/robot/report', {
    method: 'POST',
    data,
  });
}

/** 更新报告 PUT /robot/report/{reportId} */
export function updateReport(data: API.REPORT.Report) {
  return request<API.CommonResponse<API.REPORT.Report>>(`/robot/report`, {
    method: 'PUT',
    data,
  });
}

/** 删除报告 DELETE /robot/report/{reportId} */
export function deleteReport(reportId: number) {
  return request<API.CommonResponse<API.REPORT.Report>>(
    `/robot/report/${reportId}`,
    {
      method: 'DELETE',
    },
  );
}

/** 任务途径点所有坐标列表 GET /robot/waypoint/sample/listAll */
export function getTaskRobotPathPoints(taskId: number) {
  return request<API.CommonResponse<API.TASK.TaskPathPoint[]>>(
    '/robot/waypoint/sample/listAll',
    {
      method: 'GET',
      params: { taskId },
    },
  );
}

/** 任务节点记录列表 GET /robot/record/list/{taskId} */
export function getTaskRecords(
  taskId: number,
  params: API.PageParams = {
    pageNum: 1,
    pageSize: 1000,
  },
) {
  return request<API.ListResponse<API.TASK.Record>>(
    `/robot/record/list/${taskId}`,
    {
      method: 'GET',
      params,
    },
  );
}

/** 异常事件列表 GET /robot/event/list */
export function getExceptionEventList(
  taskId: number,
  data: API.PageParams & API.EVENT.EventSearch = {
    pageNum: 1,
    pageSize: 100,
  },
) {
  return request<API.ListResponse<API.EVENT.Event>>('/robot/event/list', {
    method: 'GET',
    params: {
      taskId,
      ...data,
    },
  });
}

/** 任务统计信息 GET /robot/report/pickupInfo?taskId={taskId} */
export function getTaskStats(taskId: number) {
  return request<API.CommonResponse<API.TASK.Statistics>>(
    `/robot/report/pickupInfo/${taskId}`,
    {
      method: 'GET',
    },
  );
}

export const REPORT_TASK_STATUS: Record<
  API.REPORT.TaskStatus,
  { value: number; label: string; color: string }
> = {
  0: {
    value: 0,
    label: '未完成',
    color: 'processing',
  },
  1: {
    value: 1,
    label: '作业完成',
    color: 'success',
  },
  2: {
    value: 2,
    label: '作业中止',
    color: 'warning',
  },
};

export const REPORT_PILE_STATUS: Record<
  API.REPORT.PileStatus,
  { value: number; label: string; color: string }
> = {
  0: {
    value: 0,
    label: '未回桩',
    color: 'processing',
  },
  1: {
    value: 1,
    label: '回桩成功（自主）',
    color: 'success',
  },
  2: {
    value: 2,
    label: '回桩成功（接管）',
    color: 'success',
  },
  3: {
    value: 3,
    label: '回桩失败',
    color: 'error',
  },
};

export const EXCEPTION_STATUS: Record<
  API.REPORT.ExceptionStatus,
  { value: number; label: string; color: string }
> = {
  0: {
    value: 0,
    label: '无异常',
    color: 'var(--ant-color-success)',
  },
  1: {
    value: 1,
    label: '已处理',
    color: 'var(--ant-color-text-description)',
  },
  2: {
    value: 2,
    label: '未处理',
    color: 'var(--ant-color-error)',
  },
};

export const REPORT_TASK_STATISTICS: Record<
  keyof Omit<API.TASK.Statistics, 'taskId'>,
  string
> = {
  total: '捡拾垃圾总览',
  cleaned: '已清理垃圾数量',
  cleanRate: '清理率',
  description: '未清理垃圾说明',
};

export const REPORT_READ_STATUS: Record<
  string,
  {
    value: number | undefined;
    label: string;
  }
> = {
  all: {
    value: undefined,
    label: '全部',
  },
  unread: {
    value: 0,
    label: '未读',
  },
};
